// extracted by mini-css-extract-plugin
module.exports = {"cardsList":"Card_cardsList__3zooZ","cardsListContent":"Card_cardsListContent__QKCMo","card":"Card_card__mDIW0"};